export default [
  {
    path: "statistics",
    name: "statistics",
    component: (): Promise<any> => import(/* webpackChunkName: "advertiser:statistics" */ "@/views/Advertiser/StatisticView.vue")
  }
];
